"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _reactRouterDom = require("react-router-dom");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
require("./themes/DefaultTheme.css");
var theme = {
  "sidebar-link": "DefaultTheme__sidebar-link___2j3Ea",
  "icon": "DefaultTheme__icon___3DO_l",
  "anchor": "DefaultTheme__anchor___1Xu1v",
  "active": "DefaultTheme__active___2kAKB",
  "sidebarLink": "DefaultTheme__sidebar-link___2j3Ea"
};
/**
 * The primary navigation element within an Anypoint product.
 * Either an href or an onClick must be provided.
 * If an onClick is provided with no href, we assume it's for scenarios where the user wants to display a modal.
 */
var SidebarLink = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SidebarLink, _React$Component);
  function SidebarLink(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, SidebarLink);
    _this = _callSuper(this, SidebarLink, [props]);
    var href = props.href,
      onClick = props.onClick;
    if (!href && !onClick) {
      throw new Error('href or onClick must be provided for SidebarLink');
    }
    var isNotAbsoluteOrHash = href && !(href[0] === '/' || href[0] === '#');
    if (isNotAbsoluteOrHash) {
      throw new Error('SidebarLink hrefs must start with a "/" or "#"');
    }
    return _this;
  }

  /**
   * For now we make some basic naive assumptions:
   * 1. href are absolute, e.g. "/dashboards/#foo/bar"
   * 2. hrefs do not overlap, e.g. "/dashboards/#foo/bar/baz" would not be a sidebar link
   */
  (0, _createClass2["default"])(SidebarLink, [{
    key: "isActive",
    value: function isActive() {
      var _this$props = this.props,
        isActive = _this$props.isActive,
        href = _this$props.href;
      if (isActive) {
        return isActive;
      } else if (href) {
        var currentPath = window.location.pathname + window.location.hash;
        // Note: Just in case, we avoid startsWith here since IE11 doesn't support it
        return currentPath.indexOf(href) === 0;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        label = _this$props2.label,
        icon = _this$props2.icon,
        href = _this$props2.href,
        onClick = _this$props2.onClick,
        testId = _this$props2.testId;
      var classes = (0, _classnames["default"])(theme.anchor, this.isActive() && theme.active);
      var ariaCurrent = this.isActive() ? 'page' : undefined;
      // If it's a hash href, uses an <a>, otherwise uses a React Router v4 Link.
      // If there's no href, then render an <a> with onClick.
      // This scenario can be used if the SideBarLink user wants to display a modal.
      var isAbsolutePath = href && href.indexOf('/') === 0;
      var link = isAbsolutePath ?
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/aria-props
      _react["default"].createElement(_reactRouterDom.Link, {
        className: classes,
        to: href,
        onClick: onClick,
        "aria-current": ariaCurrent
      }, icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: theme.icon,
        name: icon,
        size: "xs"
      }), label) :
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/aria-props
      _react["default"].createElement("a", {
        className: classes,
        href: href,
        onClick: onClick,
        "aria-current": ariaCurrent
      }, icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: theme.icon,
        name: icon,
        size: "xs"
      }), label);
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: theme.sidebarLink,
        "data-test-id": testId
      }, link);
    }
  }]);
  return SidebarLink;
}(_react["default"].Component);
//# sourceMappingURL=index.js.map